// extracted by mini-css-extract-plugin
export default {"no_data":"VerificationCell_no_data__advsA"};